/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFitWidth = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 4v16h-2v-5.865l-4.36 3.634-1.28-1.537L19.437 12 14.36 7.769l1.28-1.537L20 9.865V4zM4 4v5.864l4.36-3.632 1.28 1.537L4.562 12l5.078 4.232-1.28 1.537L4 14.135V20H2V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFitWidth as FitWidth };
